module.exports = __webpack_public_path__ + "static/media/instituciones-cientificas-profesionales-mini.7404d55d.jpg";